// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__1LTUI"};